import { type ActionReducerMapBuilder, createAction } from '@reduxjs/toolkit';

import type { StartAppListening } from '@/store/listenerMiddleware.ts';
import { saveCurrentSharedTab } from '@/store/sharedWorkspace/saveCurrentSharedTab.ts';
import type { TabsState } from '@/store/tabs/types.ts';

export const onClickSaveSharedTabUserList = createAction<{ users: string[] }>('onClickSaveSharedTabUserList');

export function reduceTabsSliceOnSaveSharedUserList(builder: ActionReducerMapBuilder<TabsState>) {
  builder.addCase(onClickSaveSharedTabUserList, (state, action) => {
    const activeTabId = state.tabs.ids.includes(state.activeTabId) ? state.activeTabId : (state.tabs.ids[0] ?? '');

    const currentTab = state.tabs.entities[activeTabId];

    if (!currentTab?.isShared) {
      console.warn(
        'try to update shared tab user list, but either selected tab is not found or it is not a shared tab',
        {
          currentTab,
        },
      );
      return;
    }

    currentTab.sharedWithUsers = action.payload.users;
  });
}

export function registerOnSaveSharedTabUserListEffect(startAppListening: StartAppListening) {
  startAppListening({
    actionCreator: onClickSaveSharedTabUserList,
    effect: (_action, { getState, dispatch }) => {
      saveCurrentSharedTab({ getState, dispatch });
    },
  });
}
